import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { Helmet } from 'react-helmet-async';
import axiosInstance from "../utils/axiosInstance";

const EmailVerification = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const email = searchParams.get("email");
  const [loading, setLoading] = useState(true);
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const res = await axiosInstance.post(`${process.env.REACT_APP_API_BASE}/api/auth/verify-email`, { email });
        if (res.data.success) {
          setVerified(true);
          toast.success("Email verified successfully!");
          setTimeout(() => navigate("/login"), 3000); // Redirect after 3 seconds
        } else {
          setVerified(false);
          toast.error("Invalid or expired verification link.");
        }
      } catch (err) {
        console.error("Email verification failed:", err);
        setVerified(false);
        toast.error("Error verifying email. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    if (email) {
      verifyEmail();
    } else {
      setLoading(false);
      setVerified(false);
      toast.error("Invalid verification link.");
    }
  }, [email, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-white to-indigo-200 flex items-center justify-center px-4">
      <Helmet>
        <title>PairLingo - Email verification</title>
        <meta name="description" content="Find your perfect language partner on PairLingo." />
        <meta name="keywords" content="language learning, pairlingo, chat, match" />
      </Helmet>
      <div className="bg-white rounded-xl shadow-lg w-full max-w-md p-8 text-center">
        {loading ? (
          <h2 className="text-2xl font-bold text-indigo-700">Verifying your email...</h2>
        ) : (
          <h2 className={`text-2xl font-bold ${verified ? "text-green-600" : "text-red-600"}`}>
            {verified ? "Email Verified!" : "Verification Failed"}
          </h2>
        )}
        <p className="text-gray-600 mt-2">
          {verified
            ? "You will be redirected to the login page shortly."
            : "Please check the link or try again later."}
        </p>
      </div>
    </div>
  );
};

export default EmailVerification;